import type { MetricFormat, ReportValue } from './types';

export function formatReportValue(
  value: ReportValue,
  format: MetricFormat,
  currency = 'DKK',
  locale = 'da-DK',
): string {
  if (value == null || value === '') return '—';
  if (format === 'text') return String(value);
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—';

  if (format === 'integer') {
    return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(Math.round(value));
  }
  if (format === 'decimal') {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(value);
  }
  if (format === 'percent') {
    return new Intl.NumberFormat(locale, {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    }).format(value);
  }
  return (value / 100).toLocaleString(locale, {
    style: 'currency',
    currency,
  });
}

export function formatMoneyCents(cents: number, currency = 'DKK', locale = 'da-DK'): string {
  return (cents / 100).toLocaleString(locale, { style: 'currency', currency });
}

export function csvEscape(value: string): string {
  if (/[",\n\r]/.test(value)) return `"${value.replace(/"/g, '""')}"`;
  return value;
}

export function downloadBlob(contents: Blob, filename: string) {
  const url = URL.createObjectURL(contents);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
